import React, { Suspense } from 'react';

import { useAppSelector } from '@/features/hooks';
import type { RootState } from '@/features/store';

const DEFAULT_SELECTOR = (_state: RootState) => true;

/**
 * Компонент высшего порядка с условием на отображение
 * и оберткой Suspense для ленивых компонентов
 */
export function withHiddenLazyComponent<T extends object>(
  Component: React.ComponentType<T>,
  selector = DEFAULT_SELECTOR,
) {
  function LazyComponent(props: T) {
    const isShow = useAppSelector(selector);

    if (!isShow) {
      return null;
    }

    return (
      <Suspense>
        <Component {...props} />
      </Suspense>
    );
  }

  LazyComponent.displayName = `withHiddenLazyComponent(${
    Component.displayName || Component.name
  })`;

  return LazyComponent;
}

export default withHiddenLazyComponent;
